<my-bill-odb-page-base-structure
  [hasCustomHeader]="true"
  [leftColumnClassWidth]="'medium-8'"
  [rightColumnClassWidth]="'medium-4'"
>
  <div customHeader class="columns small-12 medium-10">
    <my-bill-overview-header
      [mainTitle]="'bills.evolutionChart.title' | translate"
      [shouldDisplayBackButton]="false"
    ></my-bill-overview-header>
    <my-bill-evolution-tab
      [isEvolutionTabActive]="true"
    ></my-bill-evolution-tab>
  </div>
  <div class="rs-panel-big rs-bg-c2" leftColumnContent>
    <my-bill-evolution-chart-skeleton
      *ngIf="isFetching && !hasError"
    ></my-bill-evolution-chart-skeleton>
    <ng-container *ngIf="!isFetching && hasError">
      <lib-generic-message-box
        [messageType]="messageBoxTypeError"
        [cypressTag]="'evolutionError'"
        [showCross]="false"
      >
        <ng-container Title>{{
          'bills.redesign.errors.title' | translate
        }}</ng-container>
        <p Content>
          {{ 'bills.redesign.errors.description' | translate }}
        </p>
      </lib-generic-message-box>
    </ng-container>
    <my-bill-evolution-chart-new-customer-panel
      *ngIf="evolutionByMonth && !isFetching && !hasError"
      [evolutionByMonth]="evolutionByMonth"
    >
    </my-bill-evolution-chart-new-customer-panel>
    <ng-container *ngIf="evolutionByMonth && !isFetching && !hasError">
      <my-bill-evolution-chart
        [evolutionByMonth]="evolutionByMonth"
        (itemClick)="onMonthItemClick($event)"
      >
      </my-bill-evolution-chart>
      <my-bill-evolution-chart-legend
        [aggregatorMonth]="displayedAggregatorMonth"
      >
      </my-bill-evolution-chart-legend>
    </ng-container>
  </div>
</my-bill-odb-page-base-structure>
